module.exports = __webpack_public_path__ + "img/ic-devices-active.a07cc303.svg";